export default __webpack_public_path__ + "static/media/membrana-consejo.3aa2f7c5.png";